// Przycisk logowania - wariant Wise UI.
// Otwiera popover z nowym formularzem logowania (WiseLogin w trybie isPopover).

import React, { useState } from 'react';
import classnames from 'classnames';
import Popover from '@mui/material/Popover';
import { useTranslation } from 'react-i18next';

import { useRWD } from 'hooks';
import WiseLogin from 'pages/wise/WiseLogin/WiseLogin';

import styles from 'theme/components/wise/WiseLoginButton/WiseLoginButton.module.scss';

const WiseLoginButton = () => {
  const { t } = useTranslation();

  const { isMobile } = useRWD();

  const [popoverAnchor, setPopoverAnchor] = useState<HTMLButtonElement | null>(null);

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Wise-WiseLoginButton'
      )}>
      <button
        className={styles.authButton}
        onClick={(event) => setPopoverAnchor(event.currentTarget)}>
        {t('Logowanie/Rejestracja')}
      </button>

      <Popover
        anchorEl={popoverAnchor}
        open={!!popoverAnchor && !isMobile}
        onClose={() => setPopoverAnchor(null)}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        classes={{ paper: styles.popoverPaper }}>
        <WiseLogin isPopover />
      </Popover>
    </div>
  );
};

export default WiseLoginButton;
